// @ts-nocheck
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/I18nContext';

const APP_NAME      = process.env.REACT_APP_NAME || 'SS Real Estate Manager';
const APP_SHORT     = process.env.REACT_APP_NAME_SHORT || 'SREM';
const APP_VERSION   = process.env.REACT_APP_VERSION || 'v1.5.2';

export default function Sidebar({ show, onClose }) {
    const { user, hasRole, can, moduleOn } = useAuth();
    const { t, lang } = useI18n();

    const brandBlock = (
        <div className="sidebar-header">
            <div className="d-flex align-items-center gap-2 text-white">
                <i className="bi bi-house-heart-fill fs-3 flex-shrink-0" aria-hidden="true" />
                <div className="min-w-0 overflow-hidden">
                    <div className="brand-title text-truncate">
                        <span className="brand-full">{APP_NAME}</span>
                        <span className="brand-short">{APP_SHORT}</span>
                    </div>
                    <small className="brand-version text-white-50">
                        <span className="brand-full">{APP_VERSION}</span>
                        <span className="brand-short">{APP_VERSION}</span>
                    </small>
                </div>
            </div>
        </div>
    );

    const footerBlock = (
        <div className="sidebar-footer text-white">
            <div className="small opacity-75">{t('loggedInAs')}</div>
            <div className="fw-semibold text-truncate">{user?.name}</div>
            {/* <div className="badge bg-light text-dark mt-1 text-uppercase">{user?.role}</div> */}
        </div>
    );

    const linkClass = ({ isActive }) => `nav-link ${isActive ? 'active' : ''}`;

    if (user?.role === 'customer') {
        if (!moduleOn('portal')) {
            return (
                <aside className={`sidebar text-white ${show ? 'show' : ''}`}>
                    {brandBlock}
                    <div className="sidebar-nav p-3">{t('portalDisabled')}</div>
                </aside>
            );
        }
        const customerLinks = [
            { to: '/portal', icon: 'bi-house-door', label: t('myPortal') },
            { to: '/portal/bookings', icon: 'bi-journal-check', label: t('myBookings') },
            { to: '/portal/payments', icon: 'bi-receipt', label: t('myPayments') },
            ...(moduleOn('chat')
                ? [{ to: '/chat', icon: 'bi-chat-dots', label: t('chat') }]
                : []),
            { to: '/profile', icon: 'bi-person', label: t('profile') },
        ];
        return (
            <aside className={`sidebar text-white ${show ? 'show' : ''}`}>
                {brandBlock}
                <nav className="sidebar-nav nav flex-column flex-nowrap">
                    {customerLinks.map((l) => (
                        <NavLink key={l.to} to={l.to} className={linkClass} onClick={onClose} end={l.to === '/portal'}>
                            <i className={`bi ${l.icon} me-2`} />
                            <span>{l.label}</span>
                        </NavLink>
                    ))}
                </nav>
                {footerBlock}
            </aside>
        );
    }

    const staffLinks = [
        { to: '/dashboard', icon: 'bi-speedometer2', label: t('dashboard'), perm: 'dashboard.view', mod: 'dashboard' },
        { to: '/projects', icon: 'bi-building', label: t('projects'), perm: 'projects.view', mod: 'projects' },
        { to: '/units', icon: 'bi-grid-3x3-gap', label: t('inventory'), perm: 'units.view', mod: 'units' },
        { to: '/materials', icon: 'bi-boxes', label: t('materials'), perm: 'materials.view', mod: 'materials' },
        { to: '/leads', icon: 'bi-people', label: t('crm'), perm: 'leads.view', mod: 'leads' },
        { to: '/bookings', icon: 'bi-journal-check', label: t('bookings'), perm: 'bookings.view', mod: 'bookings' },
        { to: '/payments', icon: 'bi-cash-stack', label: t('payments'), perm: 'payments.view', mod: 'payments' },
        { to: '/accounts', icon: 'bi-calculator', label: t('accounts'), perm: 'accounts.view', mod: 'accounts' },
        {
            to: '/accounting-reports',
            icon: 'bi-journal-richtext',
            label: t('acReports'),
            perm: 'accounts.view',
            mod: 'accounting_reports',
        },
        {
            to: '/bank-assets',
            icon: 'bi-bank',
            label: t('bankAssets'),
            perm: 'accounts.view',
            mod: 'bank',
        },
        { to: '/advanced', icon: 'bi-lightning', label: t('advanced'), perm: 'accounts.view', mod: 'accounts' },
        { to: '/reports', icon: 'bi-bar-chart-line', label: t('reports'), perm: 'reports.view', mod: 'reports' },
        { to: '/chat', icon: 'bi-chat-dots', label: t('chat'), perm: 'dashboard.view', mod: 'chat' },
    ].filter((l) => can(l.perm) && moduleOn(l.mod));

    const adminLinks = [];
    if (hasRole('admin') && moduleOn('users')) {
        adminLinks.push({ to: '/users', icon: 'bi-person-gear', label: t('users') });
    }
    if (hasRole('admin') && moduleOn('permissions')) {
        adminLinks.push({ to: '/permissions', icon: 'bi-shield-lock', label: t('permissions') });
    }
    if (hasRole('admin')) {
        adminLinks.push({ to: '/system', icon: 'bi-gear', label: t('system') });
    }

    return (
        <aside className={`sidebar text-white ${show ? 'show' : ''}`}>
            {brandBlock}
            <nav className="sidebar-nav nav flex-column flex-nowrap" aria-label="Main">
                {staffLinks.map((l) => (
                    <NavLink key={l.to} to={l.to} className={linkClass} onClick={onClose}>
                        <i className={`bi ${l.icon} me-2`} />
                        <span>{l.label}</span>
                    </NavLink>
                ))}
                {adminLinks.map((l) => (
                    <NavLink key={l.to} to={l.to} className={linkClass} onClick={onClose}>
                        <i className={`bi ${l.icon} me-2`} />
                        <span>{l.label}</span>
                    </NavLink>
                ))}
            </nav>
            {footerBlock}
        </aside>
    );
}
